<template>
  <v-app style="background-color:white">

    <v-card class="form-container" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12 md5 style="padding-right:10px;">
            <a :href=src target="_blank">
             <img class="center" :src=src style="cursor:pointer;border:1px solid;height:200px;"/>
            </a>
          </v-flex>
          <v-flex xs12 sm12 md7>
              <p>Order ID : {{order.orderCode}}</p>
              <p>Order Date : {{order.date}}</p>
              <v-divider></v-divider>
              <p>Customer Name : {{customer.fullName}}</p>
              <p>Customer Mobile No : {{customer.mobileNumber}}</p>
          </v-flex>

          <v-flex xs12 style="padding-top:25px;">
              <p class="container" v-for="item in remarks" :key="item.id" style="background-color:#b9dcf7;margin-bottom:10px;">
                  Vendor Name : {{item.vendorName}}<br/>
                  Contact Number : {{item.contactNumber}}<br/><br/>
                  {{item.remark}}
              </p>
          </v-flex>
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Back</v-btn>
          </v-flex>
          
        </v-layout>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      edit: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "UOM",
          disabled: false,
          to: "/uom"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],
      order: {
      },
      customer: {
      },
      remarks: [],

      src: null
    };
  },

  mounted() {
    this.axios
      .get(config.API + `Orders1/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.src = res.data.order.src;
        this.order = res.data.order;
        this.remarks = res.data.remarks;
        this.customer = res.data.customer;
      });
  },



  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `OrderRemarks`,
            {
              orderId: JSON.parse(this.$route.params.id),  
              remark: this.form.remark
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.$router.push(`/comment`);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
